/**
 * 1011 算法备案:境外出图渠道(GPT / Gemini 系)。租户 `domesticOnly=true` 时一律不展示、不默认
 * (api 能力接口也会按租户过滤,ai 侧统一映射到国内渠道;这里是 console 兜底 —— 老 api /
 * 能力表未到货 / 草稿恢复出境外档时也不露、不提交境外项)。
 */
export const FOREIGN_IMAGE_PROVIDERS: ReadonlySet<string> = new Set([
  "OPENAI",
  "OPENAI_VIP",
  "OPENAI_FLARE",
  "OPENAI_SUNBURST",
  "GOOGLE",
]);

/** 国内出图渠道(顺序 = 默认优先级:豆包 Seedream 为默认,与 ai 侧映射一致)。 */
export const DOMESTIC_IMAGE_PROVIDERS: readonly string[] = ["DOUBAO", "WANXIANG"];

export function isForeignImageProvider(p: string | null | undefined): boolean {
  return !!p && FOREIGN_IMAGE_PROVIDERS.has(p.toUpperCase());
}

/** domesticOnly 时把境外渠道换成默认国内渠道;否则原样。 */
export function domesticProvider(p: string, domesticOnly: boolean): string {
  return domesticOnly && isForeignImageProvider(p) ? DOMESTIC_IMAGE_PROVIDERS[0] : p;
}
